<template>
  <section class="member-add-plan py-5 px-4">
    <b-container fluid>
      <div class="member-header mb-4">
        <h1 class="member-title">Agregar nuevo plan</h1>
        <p class="member-subtitle">
          Elige un plan médico y agrégalo a tu cuenta en pocos pasos.
        </p>
      </div>

      <b-spinner v-if="loading" label="Cargando..." class="d-block mx-auto my-5"></b-spinner>

      <b-alert
        v-if="errorMessage"
        variant="danger"
        :show="Boolean(errorMessage)"
        dismissible
        class="mt-3"
        @dismissed="errorMessage = null"
      >
        {{ errorMessage }}
      </b-alert>

      <div v-if="!loading && plans && plans.length > 0" class="detailed-plans-section">
        <div class="container px-0">
          <div class="section-header text-center mb-5">
            <h2 class="section-title">Planes disponibles</h2>
            <p class="section-subtitle">
              Selecciona el plan que mejor se adapte a tus necesidades.
            </p>
          </div>
          <div class="row align-items-end">
            <div
              class="col-lg-4 mb-4"
              v-for="(plan, index) in plans"
              :key="plan.id"
            >
              <div class="plan-card-wrapper">
                <PlanDetailCard
                  :plan="plan"
                  :index="index"
                  :is-visible="true"
                  :stars-icon="starsIcon"
                  :simple-purchase="true"
                  @add-plan="handleAddPlan"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-else-if="!loading" class="plans-empty text-center py-5">
        <p class="text-muted mb-0">No hay planes disponibles en este momento.</p>
      </div>
    </b-container>
  </section>
</template>

<script>
import { BContainer, BSpinner, BAlert } from 'bootstrap-vue'
import { PlanDetailCard } from '@/view/pages/landings/components'
import ToastificationContent from '@/core/plugins/toastification/ToastificationContent.vue'
import { getAllMemberPlans, addUserPlan } from '@/core/services/api/member/plans'
import memberService from '@/core/services/api/member'

const ROLE_MEMBER_ID = 10

export default {
  name: 'MemberAddPlan',
  components: {
    BContainer,
    BSpinner,
    BAlert,
    PlanDetailCard,
  },
  data() {
    return {
      loading: false,
      errorMessage: null,
      plans: [],
      starsIcon: require('@/assets/lp/plans/icons/Recurso 25@300x.png'),
    }
  },
  mounted() {
    this.fetchPlans()
  },
  methods: {
    async fetchPlans() {
      this.loading = true
      this.errorMessage = null
      try {
        const [allResponse, memberResponse] = await Promise.all([
          getAllMemberPlans(),
          memberService.filterByRole(ROLE_MEMBER_ID),
        ])

        let allPlans = []
        // API de planes devuelve { status: "ok", data: [...] }
        if (Array.isArray(allResponse?.data)) {
          allPlans = allResponse.data
        } else if (Array.isArray(allResponse)) {
          allPlans = allResponse
        }

        let memberPlans = []
        if (memberResponse?.status === 'OK' && memberResponse?.data && typeof memberResponse.data === 'object') {
          memberPlans = Object.values(memberResponse.data).filter(Array.isArray).flat()
        }

        const ownedParamIds = new Set(
          memberPlans
            .map(p => p.memberships_parameters_id)
            .filter(id => id != null)
        )

        this.plans = allPlans.filter(p => !ownedParamIds.has(p.id))
      } catch (error) {
        console.error('Error al obtener los planes para el miembro:', error)
        this.errorMessage = 'No se pudieron cargar los planes. Intenta de nuevo más tarde.'
      } finally {
        this.loading = false
      }
    },
    async handleAddPlan(plan) {
      if (!plan || !plan.id) return
      try {
        const cc = Number(plan.cc) || Number(plan.price) || 0
        await addUserPlan({
          membershipsParametersId: plan.id,
          cash: 0,
          cc,
        })
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Plan agregado',
            icon: 'CheckIcon',
            variant: 'success',
            text: 'Tu nuevo plan ha sido agregado correctamente.',
          },
        })
        this.$router.push({ name: 'member-dashboard' }).catch(() => {})
      } catch (error) {
        console.error('Error al agregar nuevo plan para el miembro:', error)
        const msg =
          error.response?.data?.message ||
          error.response?.data?.error ||
          'No se pudo agregar el plan. Intenta de nuevo.'
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error',
            icon: 'AlertCircleIcon',
            variant: 'danger',
            text: msg,
          },
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../landings/styles/variables';

.member-add-plan {
  max-width: 1100px;
  margin-left: auto;
  margin-right: auto;
}

.member-header {
  .member-title {
    font-size: clamp(1.75rem, 4vw, 2.25rem);
    font-weight: 700;
    color: $landing-primary-color;
    margin-bottom: 0.35rem;
    letter-spacing: 0.02em;
  }

.member-subtitle {
    font-size: 1.05rem;
    color: $landing-text-medium;
    margin: 0;
    line-height: 1.5;
  }
}

.detailed-plans-section {
  padding-top: 1rem;
}

.section-header .section-title {
  font-size: 1.8rem;
  font-weight: 700;
  color: $landing-primary-color;
}

.section-header .section-subtitle {
  font-size: 1rem;
  color: $landing-text-medium;
}

.plans-empty {
  .text-muted {
    font-size: 1rem;
  }
}
</style>

